<template>
	<div class="page-wrap">
		<activityHeading :activity="activity" v-on:is-gallery-active="updateGalleryActive(true)" v-on:is-book-active="updateBookActive(true)" v-on:is-video-active="updateVideoActive(true)"></activityHeading>
		<activityDetails :activity="activity"></activityDetails>
		<transition name="fade">
			<activityVideo :activity="activity" v-if="videoActive" v-on:is-video-active="updateVideoActive(false)"></activityVideo>
		</transition>
		<transition name="fade">
			<activityBook v-if="bookActive" :activity="activity" v-on:is-book-active="updateBookActive(false)"></activityBook>
		</transition>
		<transition name="fade">
			<activityGallery v-if="galleryActive" v-on:is-gallery-active="updateGalleryActive(false)" :activity="activity"></activityGallery>
		</transition>

    	<div class="anim-leave"></div> 
	</div>
</template>

<script>
   import { CATEGORIES } from '../js/categories.js';
   import activityHeading from '@/components/ActivityHeading.vue';
   import activityDetails from '@/components/ActivityDetails.vue';
   import activityVideo from '@/components/ActivityVideo.vue';
	import activityBook from '@/components/ActivityBook.vue';
	import activityGallery from '@/components/ActivityGallery.vue';

	export default {
		name: 'activity',
		components: {
			activityHeading,
			activityDetails,
			activityVideo,
			activityBook,
			activityGallery,
		},

		data: function() {
			return {
				activity: null,
				categories: CATEGORIES,
        		bookActive: false,
        		videoActive: false,
        		galleryActive: false,
			}
		},

      methods: {
      	updateVideoActive: function(isActiveVideo){
        	   this.videoActive = isActiveVideo
      	},

      	updateGalleryActive: function(isActiveGallery){
        	   this.galleryActive = isActiveGallery
      	},

         updateBookActive: function(isActiveBook){
            this.bookActive = isActiveBook
         },
      }, 

      created () {
         let params = this.$router.currentRoute.params
         let cat = this.categories.find( cat => { return cat.urlSegment === params.urlSegment })
         let subCat = cat.subCategories.find( cat => { return cat.subUrlSegment === params.subUrlSegment })
         this.activity = subCat.activities.find( act => { return act.actUrlSegment === params.actUrlSegment })
      }
   }
</script>
